import {
  GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_REQUEST,
  GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_SUCCESS,
  GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_ERROR
  } from "../actions/types";
  
  export const saleComparisionCustomerWiseInternationalReport = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_REQUEST:
        return {
          loading: true,
        };
      case GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_SALE_COMPARISION_CUSTOMER_WISE_INTERNATIONAL_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  